<template>
<div role="group" class="b-form-group form-group">
  <div slot="header">
    <strong>{{title}}</strong>
  </div>

  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('USEREMAIL')">
        <inputvalidation :formerror="formError" name="userEmail">
          <b-form-input type="email" v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('USERNAME')">
        <inputvalidation :formerror="formError" name="username">
          <b-form-input type="text" v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('PASSWORD')">
        <inputvalidation :formerror="formError" name="password">
          <b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
    
  <div class="form-row">
    <div class="col-sm-6" v-if="!newuser">
      <b-form-fieldset v-bind:label="$t('USERGROUP')">
        <inputvalidation :formerror="formError" name="groupId">
          <b-form-select :options="aclGroups.root" v-model="formData.groupId" value-field="groupId" text-field="groupName" :disabled="(globals.acl.AclGroups.deleteAction == 1) ? false : true"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('OLDSALESPORTAL')">
        <inputvalidation :formerror="formError" name="oldSalesPortal">
          <b-form-input type="text" v-model="formData.oldSalesPortal" v-bind:placeholder="$t('NAME')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('STORE')">
        <inputvalidation :formerror="formError" name="storeId">
          <b-form-select :options="store.root" v-model="formData.storeId" value-field="storeId" text-field="name"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('STARTDATE')">
        <inputvalidation :formerror="formError" name="startDate">
          <datepicker v-model="formData.startDate" name="startDate"></datepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('WAGE')">
        <inputvalidation :formerror="formError" name="wage">
          <b-form-input type="text" v-model="formData.wage" v-bind:placeholder="$t('WAGE')"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('COMMISSIONLEVEL')">
        <inputvalidation :formerror="formError" name="commissionLevel">
          <b-form-select :options="commissionLevel" v-model="formData.commissionLevel"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-12" :class="(newuser) ? 'col-sm-12' : ''">
      <b-form-fieldset v-bind:label="$t('STATUS')">
        <inputvalidation :formerror="formError" name="status">
          <b-form-select :options="status" v-model="formData.status"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('AVATAR')">
        <fileupload v-model="formData.imageFile" :chooseLabel="$t('SELECTFILE')" />
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import AclGroupsApi from '@/api/admin/AclGroups'
import UserCompaniesApi from '@/api/admin/UserCompanies'
import StoreApi from '@/api/salesportal/Store'

export default
{
  name: 'UsersForm',
  props: ['title', 'formData', 'formError', 'status', 'newuser'],
  data()
  {
    return {
      aclGroups:
      {},
      userCompanies:
      {},
      store:
      {},
      commissionLevel: [
      {
        value: '2%',
        text: '2%'
      },
      {
        value: '8.5%',
        text: '8.5%',
      }],
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 5000,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getAclGroups();
    me.getUserCompanies();
    me.getStore();
  },
  methods:
  {
    async getStore()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }

        me.store = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    getAclGroups: function()
    {
      var me = this;
      AclGroupsApi.selectRow(
      {
        start: 0,
        limit: 5000
      }, function(data)
      {
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.aclGroups = data;
      });
    },
    getUserCompanies: function()
    {
      var me = this;
      UserCompaniesApi.selectRow(me.getParams, function(data)
      {
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.userCompanies = data;
      });
    },
    saveRow(formData)
    {
      var me = this;
      me.$emit('saveRow', formData);
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ]),
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
